<template>
  <div class="container mt-2">
    <div class="row bg-warning" v-if="err">
      <div class="col">{{ err }}</div>
    </div>
    <div class="row d-flex align-items-center">
      <div class="col">
        <input type="text" class="form-control" v-model.number="pool.sort" />
      </div>
      <div class="col">
        <input type="text" class="form-control" v-model.trim="pool.name" />
      </div>
      <div class="col">
        <input type="text" class="form-control" v-model.trim="pool.count" />
      </div>
      <div class="col">
        <div class="dropdown">
          <button
            class="btn btn-secondary dropdown-toggle btn-sm"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {{ pool.count_condition }}
          </button>
          <ul class="dropdown-menu">
            <li class="dropdown-item" @click="setCondition('min')">Min</li>
            <li class="dropdown-item" @click="setCondition('equal')">Equal</li>
            <li class="dropdown-item" @click="setCondition('max')">Max</li>
          </ul>
        </div>
      </div>
      <div class="col">
        <button class="btn btn-primary btn-sm" @click="updatePool()">
          Update
        </button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { onMounted, defineProps, ref, defineEmits } from "vue";
import supabase from "@/supabase/config";
const props = defineProps(["pool"]);
const emit = defineEmits(["poolUpdated"]);
const pool = ref({});
const err = ref("");
onMounted(() => {
  pool.value = props.pool;
});
const setCondition = (str) => {
  pool.value.count_condition = str;
};
const updatePool = async () => {
  var updateObj = {
    sort: pool.value.sort,
    name: pool.value.name,
    count: pool.value.count,
    count_condition: pool.value.count_condition,
  };
  const { data, error } = await supabase
    .from("pools")
    .update(updateObj)
    .eq("id", props.pool.id)
    .select();
  if (error) {
    err.value = error.message;
    setTimeout(() => {
      err.value = "";
    }, 1000);
  } else {
    emit("poolUpdated");
  }
};
</script>
